import type { CompleteProfileForm, User } from './../modules/auth/types';
import { USER_ROLES } from './../modules/auth/types/Auth';

export function checkOnboarding(user: User) {
  switch (true) {
    case !checkUserAgreement(user, false):
      return 'user-agreement';
    case !checkUploadProfile(user, user.onboarding?.skipped_avatar || false):
      return 'upload-profile';
    case !checkCompleteProfile(user, user.onboarding?.skipped_complete_profile || false):
      return user.role === USER_ROLES.EXTERNAL_HEALTH_PROFESSIONAL ? 'upload-profile' : 'complete-profile';
    default:
      return true;
  }
}

export function checkCompleteProfile(account: CompleteProfileForm, skipped: boolean) {
  return Boolean((account.first_name && account.last_name && account.birthdate) || skipped);
}
export function checkUploadProfile(user: User, skipped: boolean) {
  return Boolean(user.avatar) || skipped;
}

export function checkUserAgreement(user: User, skipped: boolean) {
  return Boolean(user.checked_policy === 1) || skipped;
}
